import React, { useState, useRef, useEffect, useLayoutEffect } from "react"
import PropTypes from "prop-types"
import * as am5 from "@amcharts/amcharts5"
import * as am5wc from "@amcharts/amcharts5/wc"
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated"
import * as am5exporting from "@amcharts/amcharts5/plugins/exporting"

import { getNumberFormat } from "../utils/global"

const CloudWord = ({
  idChart,
  widgetTitle,
  dataChart,
  categoryData,
  valueData,
  enableExportMenu,
  numberDecimal,
  showSpaceForThousand,
  decimalSeparator,
  minWordLength,
  maxFontSize,
  colorMinValue,
  colorMaxValue,
  enableTooltip,
}) => {
  const [idChartState, setIdChartState] = useState(idChart ? idChart : `wordCloud_${Math.random()}`)

  const chartRef = useRef(null)
  const rootRef = useRef(null)
  const exportMenuRef = useRef(null)
  // LYFECYCLE
  useLayoutEffect(() => {
    initChart()

    return () => {
      if (rootRef.current !== null) {
        rootRef.current.dispose()
      }
      if (chartRef.current !== null) {
        chartRef.current.dispose()
      }
    }
  }, [])

  useLayoutEffect(() => {
    if (rootRef.current !== null) {
      setupChart(rootRef.current)
    }
  }, [decimalSeparator])
  useLayoutEffect(() => {
    if (rootRef.current !== null) {
      disposeExportMenu()
      createExportMenu(rootRef.current)
    }
  }, [enableExportMenu])
  useLayoutEffect(() => {
    if (chartRef.current !== null && rootRef.current !== null) {
      disposeChart(rootRef.current)
      createChart(rootRef.current)
    }
  }, [minWordLength, maxFontSize, dataChart, valueData, categoryData, colorMinValue, colorMaxValue])
  // useLayoutEffect(() => {
  //   if(chartRef.current !== null){
  //     if(enableTooltip){
  //       chartRef.current.labels.template.set("tooltipText", "{category}: [bold]{value}[/]");
  //     } else {
  //       chartRef.current.labels.template.set("tooltip", null);
  //     }
  //   }
  // },[enableTooltip])

  // FUNCTIONS
  const initChart = () => {
    const root = am5.Root.new(idChartState)
    root._logo.dispose()
    root.setThemes([am5themes_Animated.new(root)])

    createChart(root)
    createExportMenu(root)
    setupChart(root)

    rootRef.current = root
  }

  const createChart = root => {
    const chart = root.container.children.push(
      am5wc.WordCloud.new(root, {
        categoryField: categoryData,
        valueField: valueData,
        minWordLength: minWordLength,
        maxFontSize: am5.percent(maxFontSize),
      })
    )

    chart.data.setAll(dataChart)

    //!\ TMP SOLUTION, TO FIX

    let minColor = colorMinValue
    let maxColor = colorMaxValue

    if (colorMinValue.length === 9) {
      minColor = colorMinValue.slice(0, 7)
    }
    if (colorMaxValue.length === 9) {
      maxColor = colorMaxValue.slice(0, 7)
    }

    //!\ END TMP SOLUTION
    chart.set("heatRules", [
      {
        target: chart.labels.template,
        dataField: "value",
        min: am5.color(minColor),
        max: am5.color(maxColor),
        key: "fill",
      },
    ])

    chartRef.current = chart
  }

  const createExportMenu = root => {
    if (exportMenuRef.current === null && enableExportMenu) {
      const title = `${widgetTitle}_export`
      exportMenuRef.current = am5exporting.Exporting.new(root, {
        menu: am5exporting.ExportingMenu.new(root, {}),
        title: title,
        printOptions: {
          disabled: true,
        },
      })
    }
  }

  const setupChart = root => {
    //Language
    root.locale["_decimalSeparator"] = [".", ","].includes(decimalSeparator)
      ? decimalSeparator
      : ","
    root.locale["_thousandSeparator"] = " "

    // numberDecimals
    root.numberFormatter.set("numberFormat", getNumberFormat(numberDecimal, showSpaceForThousand))
  }

  const disposeChart = root => {
    while (root?.container?.children.length >= 1) {
      root?.container?.children.removeIndex(0).dispose()
    }
  }

  const disposeExportMenu = () => {
    if (exportMenuRef.current !== null) {
      exportMenuRef.current.get("menu").dispose()
      exportMenuRef.current.dispose()
      exportMenuRef.current = null
    }
  }

  return <div id={idChartState} style={{ width: "100%", height: "100%" }} />
}

CloudWord.propTypes = {
  idChart: PropTypes.string,
  dataChart: PropTypes.arrayOf(PropTypes.object),
  valueData: PropTypes.string,
  categoryData: PropTypes.string,
  widgetTitle: PropTypes.string,
  enableExportMenu: PropTypes.bool,
  numberDecimal: PropTypes.number,
  showSpaceForThousand: PropTypes.bool,
  decimalSeparator: PropTypes.string,
  minWordLength: PropTypes.number,
  maxFontSize: PropTypes.number,
  colorMinValue: PropTypes.string,
  colorMaxValue: PropTypes.string,
}

CloudWord.defaultProps = {
  idChart: "",
  dataChart: [],
  valueData: "",
  categoryData: "",
  widgetTitle: "My widget",
  enableExportMenu: false,
  numberDecimal: 2,
  showSpaceForThousand: true,
  decimalSeparator: ",",
  minWordLength: 2,
  maxFontSize: 35,
  colorMinValue: "#707070",
  colorMaxValue: "#000000",
  enableTooltip: false,
}

export default CloudWord
